// extracted by mini-css-extract-plugin
export var container = "reservation-detail-container-module--container--3S4PQ";
export var title = "reservation-detail-container-module--title--1qrty";
export var refresh = "reservation-detail-container-module--refresh--AQXqd";
export var cancellationFee = "reservation-detail-container-module--cancellationFee--2ekz2";
export var feeSuffix = "reservation-detail-container-module--feeSuffix--3asD0";
export var actionButtons = "reservation-detail-container-module--actionButtons--2dWVt";